const inputErrorLabelNew = {
  label: 'O campo de mensagem não pode estar vazio'
};

export default inputErrorLabelNew;
